<div class="export-modal">
  <div class="modal-header ps-24px">
    <div class="export-modal-header">
      <h5>{{ translate?.report.sections.sec11.plural }}</h5>
    </div>

    <button
      type="button"
      class="close"
      data-dismiss="modal"
      aria-label="Close"
      (click)="modalRef.hide()"
      [pTooltip]="translate?.general.buttons.close.singular"
      tooltipPosition="left"
    >
      <i class="fa-regular fa-xmark"></i>
    </button>
  </div>

  
    <div class="modal-body py-0 h-400px">
      <!-- When there's no records available -->
      <div class="h-100" *ngIf="isSchedulesFound === false">
        <app-no-records-available></app-no-records-available>
      </div>

      <!-- Displays list of available schedules -->
      <div class="position-relative col-12 d-flex display-table h-100" *ngIf="isSchedulesFound">
        <div class="ag-grid-table-full">
          <ag-grid-angular
            #agGrid
            class="ag-theme-balham h-92-prcnt"
            [headerHeight]="33"
             [rowHeight]="27" 
            [suppressDragLeaveHidesColumns]="true"
            [allowContextMenuWithControlKey]="false"
            [columnDefs]="columnDefs"
            [gridOptions]="gridOptions"
            [defaultColDef]="defaultColDef"
            [components]="frameworkComponents"
            (gridReady)="onGridReady($event)"
            [rowData]="scheduleList"
            [overlayNoRowsTemplate]="overlayNoRowsTemplate"
            [pagination]="true"
          >
          </ag-grid-angular>

          <div class="col-12">
            <p
              class="ag-record-row-summary-panel padds text-end"
              id="label_TaskJourTableRec"
            >
              {{ totalRecord }}&nbsp;{{ translate?.general.messages.records }}
            </p>
          </div>
        </div>
      </div> 
    </div>

    <div class="modal-footer">
      <button
        type="button"
        class="custella-btn-white"
        (click)="modalRef.hide()"
      >
        {{ translate?.general.buttons.cancel.singular }}
      </button>
      <p-button
        [label]="translate?.general.buttons.new.singular"
        styleClass="h-32"
        icon="fa-regular fa-plus"
        (onClick)="onClickNew()"
      >
      </p-button>
    </div>
</div>
